import React, { PropsWithChildren } from "react";
import { UploadedImageDimension } from "models/propTypes/fileViewerPropTypes";
import { FileViwerReducer } from "./reducer";
import { ContextConstants } from "utils/constants";
import { FileViewerContext, initialState } from ".";

const FileViwerContextProvider: React.FC<PropsWithChildren> = (props) => {
  const [state, dispatch] = React.useReducer(FileViwerReducer, initialState);

  const setUploadedFileDimensions = (dimensions?: UploadedImageDimension) => {
    if (JSON.stringify(state.currentFileDimensions) !== JSON.stringify(dimensions)) {
      dispatch({ type: ContextConstants.FileViewerActions.SET_UPLOADED_FILE_DIMENSIONS, payload: dimensions });
    }
  };

  const setContainerDimensions = (dimensions?: UploadedImageDimension) => {
    if (JSON.stringify(state.containerDimensions) !== JSON.stringify(dimensions)) {
      dispatch({ type: ContextConstants.FileViewerActions.SET_CONTAINER_DIMENSIONS, payload: dimensions });
    }
  };

  return (
    <FileViewerContext.Provider
      value={{
        ...state,
        setUploadedFileDimensions: setUploadedFileDimensions,
        setContainerDimensions: setContainerDimensions,
      }}
    >
      {props.children}
    </FileViewerContext.Provider>
  );
};

export default FileViwerContextProvider;
